export default "__VITE_ASSET__554ad507__"